import { render } from "./PerioGardRegimen.vue?vue&type=template&id=6144c4d5&scoped=true"
import script from "./PerioGardRegimen.vue?vue&type=script&lang=js"
export * from "./PerioGardRegimen.vue?vue&type=script&lang=js"

import "./PerioGardRegimen.vue?vue&type=style&index=0&id=6144c4d5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6144c4d5"]])

export default __exports__